import { render, staticRenderFns } from "./ManagerAccess.vue?vue&type=template&id=28cec380&"
import script from "./ManagerAccess.vue?vue&type=script&lang=js&"
export * from "./ManagerAccess.vue?vue&type=script&lang=js&"
import style0 from "./ManagerAccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ManagerAccess.vue"
export default component.exports